import { Box, Tab, Tabs } from '@mui/material';
import { styled } from '@mui/system';
import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';

import { useTranslator } from '@/hooks/useTranslator';

export const RecipientDetailsDrawer: React.FC = (): React.ReactElement => {
  const location = useLocation();
  const navigate = useNavigate();
  const tr = useTranslator();
  const path = location.pathname.split('/')[4] || 'details';

  const onTabChange = React.useCallback(
    (_: React.SyntheticEvent, value: string): void => {
      navigate(location.pathname.split('/').slice(0, 4).concat(value).join('/'));
    },
    [navigate, location],
  );

  return (
    <Box width={612} height="100%" py={2}>
      <StyledTabs value={path} aria-label={tr('EDIT_RECIPIENT_TABS')} onChange={onTabChange}>
        <Tab label={tr('DETAILS')} value="details" />
        <Tab label={tr('PAYMENT_METHODS')} value="payment-methods" />
      </StyledTabs>
      <Outlet />
    </Box>
  );
};

const StyledTabs = styled(Tabs)({
  paddingLeft: 32,
  paddingRight: 32,
});
